import { render, staticRenderFns } from "./NotApprovedRequests.vue?vue&type=template&id=3721b57d"
import script from "./NotApprovedRequests.vue?vue&type=script&lang=js"
export * from "./NotApprovedRequests.vue?vue&type=script&lang=js"
import style0 from "./NotApprovedRequests.vue?vue&type=style&index=0&id=3721b57d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports